import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form, Alert, Spinner } from "react-bootstrap";
import { alterarConfiguracao, pegarConfiguracao } from "../data/api/gsConnectApi";
import { useHistory } from 'react-router-dom';

function AutoAtendimento() {
  const [mensagemSucesso, setMensagemSucesso] = useState('');
  const [mensagemErro, setMensagemErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingConfigs, setLoadingConfigs] = useState(true);

  // Estados para configurações por instância
  const [instancias, setInstancias] = useState({
    '1': { autoResposta: { ativa: false, mensagem: '' }, agente: { ativo: false, prompt: '' } },
    '2': { autoResposta: { ativa: false, mensagem: '' }, agente: { ativo: false, prompt: '' } },
    '3': { autoResposta: { ativa: false, mensagem: '' }, agente: { ativo: false, prompt: '' } },
    '4': { autoResposta: { ativa: false, mensagem: '' }, agente: { ativo: false, prompt: '' } }
  });

  const [instanciaAtiva, setInstanciaAtiva] = useState('1');

  const history = useHistory();

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const showSuccess = (message) => {
    setMensagemSucesso(message);
    setTimeout(() => setMensagemSucesso(''), 3000);
  };

  const showError = (message) => {
    setMensagemErro(message);
    setTimeout(() => setMensagemErro(''), 5000);
  };

  const gerarPromptPadrao = () => {
    return `Você é um assistente virtual de uma clínica médica. 

Sua função é:
1. Atender os pacientes de forma cordial e profissional
2. Fornecer informações sobre a clínica, horários e especialidades
3. Auxiliar com agendamentos e dúvidas gerais
4. Sempre que não souber uma informação específica, orientar o paciente a entrar em contato diretamente

Instruções importantes:
- Seja sempre educado, prestativo e mantenha um tom profissional mas acolhedor
- Não forneça diagnósticos ou conselhos médicos específicos
- Para emergências, sempre oriente a procurar atendimento médico imediato
- Mantenha as respostas claras e objetivas

Insira abaixo as informações específicas da sua clínica (nome, especialidades, horários, contato, etc.) para personalizar o atendimento.`;
  };

  const carregarConfiguracoes = async () => {
    try {
      setLoadingConfigs(true);

      const novasInstancias = { ...instancias };

      // Carregar configurações para cada instância
      for (let i = 1; i <= 4; i++) {
        const instanciaId = i.toString();

        const [
          autoRespostaConfig,
          mensagemConfig,
          agenteConfig,
          promptConfig
        ] = await Promise.all([
          pegarConfiguracao(`AUTO_RESPOSTA_ATIVO_${instanciaId}`).catch(() => null),
          pegarConfiguracao(`AUTO_RESPOSTA_MENSAGEM_${instanciaId}`).catch(() => null),
          pegarConfiguracao(`AGENTE_IA_ATIVO_${instanciaId}`).catch(() => null),
          pegarConfiguracao(`AGENTE_IA_PROMPT_${instanciaId}`).catch(() => null)
        ]);

        novasInstancias[instanciaId] = {
          autoResposta: {
            ativa: autoRespostaConfig?.valor === 'true',
            mensagem: mensagemConfig?.valor || 'Olá! Obrigado por entrar em contato. Em breve retornaremos sua mensagem.'
          },
          agente: {
            ativo: agenteConfig?.valor === 'true',
            prompt: promptConfig?.valor || gerarPromptPadrao()
          }
        };
      }

      setInstancias(novasInstancias);

    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      showError('Erro ao carregar configurações.');
    } finally {
      setLoadingConfigs(false);
    }
  };

  const salvarConfiguracao = async (instanciaId) => {
    setLoading(true);
    try {
      const instancia = instancias[instanciaId];

      await Promise.all([
        alterarConfiguracao(`AUTO_RESPOSTA_ATIVO_${instanciaId}`, instancia.autoResposta.ativa.toString()),
        alterarConfiguracao(`AUTO_RESPOSTA_MENSAGEM_${instanciaId}`, instancia.autoResposta.mensagem),
        alterarConfiguracao(`AGENTE_IA_ATIVO_${instanciaId}`, instancia.agente.ativo.toString()),
        alterarConfiguracao(`AGENTE_IA_PROMPT_${instanciaId}`, instancia.agente.prompt)
      ]);

      showSuccess(`Configurações da instância WhatsApp ${instanciaId} salvas com sucesso!`);
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      showError('Erro ao salvar configurações.');
    } finally {
      setLoading(false);
    }
  };

  const atualizarInstancia = (instanciaId, tipo, campo, valor) => {
    // Se está tentando ativar, fazer validação
    if ((tipo === 'autoResposta' && campo === 'ativa' && valor) ||
      (tipo === 'agente' && campo === 'ativo' && valor)) {

      const instanciaAtual = instancias[instanciaId];

      // Verificar conflito apenas se está tentando ativar
      if (tipo === 'autoResposta' && instanciaAtual.agente.ativo) {
        showError(`Não é possível ativar Auto Resposta na instância ${instanciaId} pois o Agente IA já está ativo.`);
        return;
      }

      if (tipo === 'agente' && instanciaAtual.autoResposta.ativa) {
        showError(`Não é possível ativar Agente IA na instância ${instanciaId} pois a Auto Resposta já está ativa.`);
        return;
      }
    }

    // Atualizar estado sempre (inclusive para desativar)
    setInstancias(prev => ({
      ...prev,
      [instanciaId]: {
        ...prev[instanciaId],
        [tipo]: {
          ...prev[instanciaId][tipo],
          [campo]: valor
        }
      }
    }));
  };

  const regenerarPrompt = (instanciaId) => {
    atualizarInstancia(instanciaId, 'agente', 'prompt', gerarPromptPadrao());
    showSuccess('Prompt padrão carregado! Você pode editá-lo conforme necessário.');
  };

  const getTotalAtivas = () => {
    return Object.values(instancias).reduce((total, instancia) => {
      if (instancia.autoResposta.ativa || instancia.agente.ativo) total++;
      return total;
    }, 0);
  };

  // Funções específicas para os switches
  const toggleAutoResposta = async (instanciaId, valor) => {
    console.log(`Toggling auto resposta para instância ${instanciaId}:`, valor);

    // Verificar conflito imediatamente
    if (valor && instancias[instanciaId].agente.ativo) {
      showError(`Não é possível ativar Auto Resposta na instância ${instanciaId} pois o Agente IA já está ativo.`);
      return;
    }

    // Atualizar estado
    setInstancias(prev => ({
      ...prev,
      [instanciaId]: {
        ...prev[instanciaId],
        autoResposta: {
          ...prev[instanciaId].autoResposta,
          ativa: valor
        }
      }
    }));

    // Salvar automaticamente
    try {
      await alterarConfiguracao(`AUTO_RESPOSTA_ATIVO_${instanciaId}`, valor.toString());
      showSuccess(`Auto Resposta ${valor ? 'ativada' : 'desativada'} para WhatsApp ${instanciaId}`);
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      showError('Erro ao salvar configuração.');
    }
  };

  const toggleAgente = async (instanciaId, valor) => {
    console.log(`Toggling agente IA para instância ${instanciaId}:`, valor);

    // Verificar conflito imediatamente
    if (valor && instancias[instanciaId].autoResposta.ativa) {
      showError(`Não é possível ativar Agente IA na instância ${instanciaId} pois a Auto Resposta já está ativa.`);
      return;
    }

    // Atualizar estado
    setInstancias(prev => ({
      ...prev,
      [instanciaId]: {
        ...prev[instanciaId],
        agente: {
          ...prev[instanciaId].agente,
          ativo: valor
        }
      }
    }));

    // Salvar automaticamente
    try {
      await alterarConfiguracao(`AGENTE_IA_ATIVO_${instanciaId}`, valor.toString());
      showSuccess(`Agente IA ${valor ? 'ativado' : 'desativado'} para WhatsApp ${instanciaId}`);
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      showError('Erro ao salvar configuração.');
    }
  };

  if (loadingConfigs) {
    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        <div style={{ backgroundColor: '#43a047', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500' }}>
          <div className="d-flex align-items-center">
            <Button
              variant="outline-light"
              size="sm"
              style={{ borderColor: 'white', color: 'white', marginRight: 12 }}
              onClick={() => history.push('/admin/home')}
            >
              ← Voltar
            </Button>
            <span>Auto Atendimento</span>
          </div>
        </div>
        <Container fluid className="p-4">
          <div className="text-center py-5">
            <Spinner animation="border" style={{ color: '#43a047' }} />
            <p className="mt-3 text-muted">Carregando configurações...</p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ backgroundColor: '#43a047', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button
              variant="outline-light"
              size="sm"
              style={{ borderColor: 'white', color: 'white', marginRight: 12 }}
              onClick={() => history.push('/admin/home')}
            >
              ← Voltar
            </Button>
            <span>Auto Atendimento</span>
          </div>
          <span style={{
            background: '#007bff',
            color: 'white',
            padding: '6px 12px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '500'
          }}>
            {getTotalAtivas()} ativas
          </span>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alerts */}
        {mensagemSucesso && (
          <Alert variant="success" className="mb-3" dismissible onClose={() => setMensagemSucesso('')}>
            ✅ {mensagemSucesso}
          </Alert>
        )}
        {mensagemErro && (
          <Alert variant="danger" className="mb-3" dismissible onClose={() => setMensagemErro('')}>
            ❌ {mensagemErro}
          </Alert>
        )}

        {/* Tabs de Instâncias */}
        <div className="mb-4">
          <div style={{ borderBottom: '2px solid #dee2e6' }}>
            <Row>
              {[1, 2, 3, 4].map(num => {
                const instanciaId = num.toString();
                const instancia = instancias[instanciaId];
                const isActive = instanciaAtiva === instanciaId;
                const temConfig = instancia.autoResposta.ativa || instancia.agente.ativo;

                return (
                  <Col key={num} xs={3}>
                    <div
                      onClick={() => setInstanciaAtiva(instanciaId)}
                      style={{
                        padding: '12px 8px',
                        textAlign: 'center',
                        backgroundColor: isActive ? '#43a047' : '#f8f9fa',
                        color: isActive ? 'white' : '#495057',
                        cursor: 'pointer',
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px',
                        fontSize: '14px',
                        fontWeight: '500',
                        border: isActive ? '2px solid #43a047' : '2px solid transparent',
                        borderBottom: 'none',
                        position: 'relative'
                      }}
                    >
                      📱 WhatsApp {num}
                      {temConfig && (
                        <div style={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          width: '8px',
                          height: '8px',
                          backgroundColor: '#28a745',
                          borderRadius: '50%'
                        }} />
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>

        {/* Configurações da Instância Ativa */}
        <div className="bg-white mb-4" style={{ border: '1px solid #dee2e6', borderRadius: '6px' }}>
          <div style={{ backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>
            <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
              📱 Configurações WhatsApp {instanciaAtiva}
            </h6>
          </div>
          <div className="p-3">
            {/* Auto Resposta */}
            <div className="mb-4" style={{ border: '1px solid #e9ecef', borderRadius: '6px', padding: '16px' }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 style={{ color: '#495057', fontWeight: '600', margin: 0 }}>💬 Auto Resposta Automática</h6>
                <Form.Check
                  type="switch"
                  id={`switch-auto-resposta-${instanciaAtiva}`}
                  checked={instancias[instanciaAtiva].autoResposta.ativa}
                  onChange={(e) => toggleAutoResposta(instanciaAtiva, e.target.checked)}
                  style={{ fontSize: '14px' }}
                />
              </div>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Label className="small fw-medium text-muted">Mensagem de auto resposta</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={instancias[instanciaAtiva].autoResposta.mensagem}
                    onChange={(e) => atualizarInstancia(instanciaAtiva, 'autoResposta', 'mensagem', e.target.value)}
                    placeholder="Digite a mensagem que será enviada automaticamente..."
                    style={{ fontSize: '13px' }}
                    disabled={!instancias[instanciaAtiva].autoResposta.ativa}
                  />
                  <small className="text-muted">Esta mensagem será enviada automaticamente para todas as conversas novas.</small>
                </Col>
              </Row>
            </div>

            {/* Agente IA */}
            <div className="mb-4" style={{ border: '1px solid #e9ecef', borderRadius: '6px', padding: '16px' }}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 style={{ color: '#495057', fontWeight: '600', margin: 0 }}>🤖 Agente IA Inteligente</h6>
                <Form.Check
                  type="switch"
                  id={`switch-agente-ia-${instanciaAtiva}`}
                  checked={instancias[instanciaAtiva].agente.ativo}
                  onChange={(e) => toggleAgente(instanciaAtiva, e.target.checked)}
                  style={{ fontSize: '14px' }}
                />
              </div>

              <Row className="mb-3">
                <Col md={12}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <Form.Label className="small fw-medium text-muted mb-0">Prompt do Agente IA</Form.Label>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => regenerarPrompt(instanciaAtiva)}
                      style={{ fontSize: '11px' }}
                      disabled={!instancias[instanciaAtiva].agente.ativo}
                    >
                      🔄 Prompt Padrão
                    </Button>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    value={instancias[instanciaAtiva].agente.prompt}
                    onChange={(e) => atualizarInstancia(instanciaAtiva, 'agente', 'prompt', e.target.value)}
                    placeholder="Configure como o agente IA deve se comportar e responder..."
                    style={{ fontSize: '12px', fontFamily: 'monospace' }}
                    disabled={!instancias[instanciaAtiva].agente.ativo}
                  />
                  <small className="text-muted">
                    Este prompt define como o agente IA irá se comportar. Inclua aqui as informações da sua clínica (nome, especialidades, horários, contato, etc.).
                  </small>
                </Col>
              </Row>
            </div>

            <div className="text-end">
              <Button
                variant="success"
                onClick={() => salvarConfiguracao(instanciaAtiva)}
                disabled={loading}
                style={{ backgroundColor: '#43a047', borderColor: '#43a047', fontSize: '13px' }}
              >
                {loading ? <Spinner size="sm" className="me-2" /> : null}
                Salvar Configurações WhatsApp {instanciaAtiva}
              </Button>
            </div>
          </div>
        </div>

        {/* Resumo das Instâncias */}
        <div className="bg-white mb-4" style={{ border: '1px solid #dee2e6', borderRadius: '6px' }}>
          <div style={{ backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>
            <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>📊 Resumo das Configurações</h6>
          </div>
          <div className="p-3">
            <Row>
              {[1, 2, 3, 4].map(num => {
                const instanciaId = num.toString();
                const instancia = instancias[instanciaId];

                return (
                  <Col key={num} md={3} className="mb-3">
                    <div style={{
                      border: '1px solid #dee2e6',
                      borderRadius: '6px',
                      padding: '12px',
                      textAlign: 'center',
                      backgroundColor: (instancia.autoResposta.ativa || instancia.agente.ativo) ? '#e8f5e8' : '#f8f9fa'
                    }}>
                      <div style={{ fontSize: '20px', marginBottom: '8px' }}>📱</div>
                      <h6 style={{ margin: '0 0 8px 0', fontSize: '14px' }}>WhatsApp {num}</h6>
                      <div style={{ fontSize: '12px' }}>
                        {instancia.autoResposta.ativa && (
                          <div style={{ color: '#28a745', marginBottom: '4px' }}>
                            ✅ Auto Resposta
                          </div>
                        )}
                        {instancia.agente.ativo && (
                          <div style={{ color: '#007bff', marginBottom: '4px' }}>
                            ✅ Agente IA
                          </div>
                        )}
                        {!instancia.autoResposta.ativa && !instancia.agente.ativo && (
                          <div style={{ color: '#6c757d' }}>
                            ❌ Inativo
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>

        {/* Card de Informações */}
        <div className="bg-white" style={{ border: '1px solid #dee2e6', borderRadius: '6px' }}>
          <div className="p-3">
            <h6 className="mb-3" style={{ color: '#43a047', fontWeight: '600' }}>💡 Como funciona o Auto Atendimento por Instância</h6>
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <h6 style={{ color: '#495057', fontSize: '14px', fontWeight: '600' }}>💬 Auto Resposta</h6>
                  <ul style={{ fontSize: '13px', color: '#6c757d', paddingLeft: '20px' }}>
                    <li>Mensagem automática personalizada por instância</li>
                    <li>Resposta imediata para novos contatos</li>
                    <li>Ideal para horários de atendimento</li>
                  </ul>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <h6 style={{ color: '#495057', fontSize: '14px', fontWeight: '600' }}>🤖 Agente IA</h6>
                  <ul style={{ fontSize: '13px', color: '#6c757d', paddingLeft: '20px' }}>
                    <li>Prompt personalizado por instância</li>
                    <li>Inteligência artificial adaptativa</li>
                    <li>Atendimento 24/7 automatizado</li>
                  </ul>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-3">
                  <h6 style={{ color: '#495057', fontSize: '14px', fontWeight: '600' }}>⚠️ Importante</h6>
                  <ul style={{ fontSize: '13px', color: '#6c757d', paddingLeft: '20px' }}>
                    <li>Apenas uma função ativa por instância</li>
                    <li>Auto Resposta e Agente IA são exclusivos</li>
                    <li>Configure cada WhatsApp independentemente</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default AutoAtendimento;